import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AvpHeader from "../shared/header/AvpHeader";
import AvpSaveFooter from "../shared/footer/AvpSaveFooter";
import BreadCrumb from "../shared/header/BreadCrumb";
import {
  userIsLogged,
  getRoute,
  apiPostSysLingua,
  apiGetSysLingua,
} from "../shared/manager/api_manager";
import { useEffectOnce } from "../shared/manager/use_effect_once";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import { useLingueStore } from "../sistema/storeLingua";

export default function GestioneLingueDetailScreen() {
  const navigate = useNavigate();

  const [alertSuccessOpen, setAlertSuccessOpen] = useState(false);
  const [alertErrorOpen, setAlertErrorOpen] = useState(false);
  const { selectedLinguaTesto } = useLingueStore((state) => state);
  let breadCrumb = [
    { title:selectedLinguaTesto?.GestioneLingueDetailBreadcrumb1, link: "/sistema" },
    { title:selectedLinguaTesto?.GestioneLingueDetailBreadcrumb2 , link: "/sistema/lingue" },
  ];

  const [selectedLingua, setSelectedLingua] = useState(null);
  const [pageAction, setPageAction] = useState("new");

  //FORM
  const [formCodLinguaStatus, setFormCodLingua] = useState("");
  const [formDescrizioneStatus, setFormDescrizioneStatus] = useState("");

  const formCodLinguaInput = React.useRef();
  const formDescrizioneInput = React.useRef();

  useEffectOnce(() => {
    startPage();

    return () => stopPage();
  });

  function startPage() {
    console.log("startPage");
    if (userIsLogged() == false) {
      navigate("/login");
    } else {
      var route = getRoute();
      if (!route.funzioni.some((g) => g.idFunzione === 40)) {
        navigate("/");
      }
      initPage();
    }
  }

  function stopPage() {
    console.log("stopPage");
  }

  function initPage() {
    console.log("initPage");

    loadLingua();
  }

  function loadLingua() {
    const url = window.location.pathname;
    const idLingua = url.substring(url.lastIndexOf("/") + 1);

    if (idLingua !== null && idLingua !== "" && idLingua != "-1") {
      //edit
      setPageAction("edit");

      apiGetSysLingua(idLingua, function (response) {
        if (
          response != null &&
          response.status >= 200 &&
          response.status < 400
        ) {
          setSelectedLingua(response.data);
        }
      });
    } else {
      //new
      setPageAction("new");
      let newLanguage = {
        codLingua: "",
        descrizione: "",
        linguaDefault: false,
      };
      setSelectedLingua(newLanguage);
    }
  }

  function handleCodLinguaField(event) {
    let value = event.target.value;
    selectedLingua.codLingua = value;
    let newObj = Object.assign({}, selectedLingua);
    setSelectedLingua(newObj);
  }

  function handleDescrizioneField(event) {
    let value = event.target.value;
    selectedLingua.descrizione = value;
    let newObj = Object.assign({}, selectedLingua);
    setSelectedLingua(newObj);
  }

  function validateForm() {
    console.log("validateForm");
    let valid = true;

    const codLingua = formCodLinguaInput.current.value;
    const descrizione = formDescrizioneInput.current.value;

    if (codLingua == null || codLingua == "") {
      valid = false;
      setFormCodLingua(" notvalid");
    } else {
      setFormCodLingua("");
    }

    if (descrizione == null || descrizione == "") {
      valid = false;
      setFormDescrizioneStatus(" notvalid");
    } else {
      setFormDescrizioneStatus("");
    }

    return valid;
  }

  function saveLingua() {
    if (selectedLingua != null) {
      apiPostSysLingua(selectedLingua, function (response) {
        if (
          response != null &&
          response.status >= 200 &&
          response.status < 400
        ) {
          setAlertSuccessOpen(true);
          setAlertErrorOpen(false);
          navigate("/sistema/lingue");
        } else {
          setAlertSuccessOpen(false);
          setAlertErrorOpen(true);
        }
      });
    } else {
      console.log("Selected user is null");
    }
  }

  function footerCancelCallback() {
    console.log("cancel");
    navigate("/sistema/lingue");
  }

  function footerSaveCallback() {
    console.log("save");

    if (validateForm()) {
      saveLingua();
    }
  }

  return (
    <div id="avp-gestionecontenuti-screen">
      <AvpHeader selectedMenuId={"contenuti"} />
      <BreadCrumb
        items={breadCrumb}
        helpLink={"help.html#modificagruppoutenti"}
      />
      <div id="avp-cms-screen-container">
        <Collapse in={alertSuccessOpen}>
          <Alert
            variant="filled"
            severity="success"
            onClose={() => {
              setAlertSuccessOpen(false);
            }}
          >
          {selectedLinguaTesto?.GestioneLingueDetailAlertSucess}  
          </Alert>
        </Collapse>
        <Collapse in={alertErrorOpen}>
          <Alert
            variant="filled"
            severity="error"
            onClose={() => {
              setAlertErrorOpen(false);
            }}
          >
           {selectedLinguaTesto?.GestioneLingueDetailAlertError} 
          </Alert>
        </Collapse>

        <div className="avp-cms-screen-content">
          <div className="avp-cms-screen-content-row clearfix">
            <div className="avp-gestioneavp-nodearcs-section-title">
             {selectedLinguaTesto?.GestioneLingueDetailTitle} 
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <div className="avp-cms-screen-content-col50">
              <div className="avp-cms-screen-content-row clearfix">
                <div
                  className="avp-cms-screen-content-column"
                  style={{ width: "50%" }}
                >
                  <label htmlFor="avp-form-nome" className="required">
                  {selectedLinguaTesto?.GestioneLingueDetailCodLang} 
                  </label>
                  <br />
                  <input
                    id="avp-form-nome"
                    ref={formCodLinguaInput}
                    className={formCodLinguaStatus}
                    style={{ maxWidth: "none" }}
                    type="text"
                    value={
                      selectedLingua != null ? selectedLingua.codLingua : ""
                    }
                    onChange={handleCodLinguaField}
                  />
                </div>
              </div>
              <div className="avp-cms-screen-content-row clearfix">
                <div
                  className="avp-cms-screen-content-column"
                  style={{ width: "50%" }}
                >
                  <label htmlFor="avp-form-rifamm" className="required">
                  {selectedLinguaTesto?.GestioneLingueDetailDesc}  
                  </label>
                  <br />
                  <input
                    id="avp-form-rifamm"
                    ref={formDescrizioneInput}
                    className={formDescrizioneStatus}
                    style={{ maxWidth: "none" }}
                    type="text"
                    value={
                      selectedLingua != null ? selectedLingua.descrizione : ""
                    }
                    onChange={handleDescrizioneField}
                  />
                </div>
              </div>
            </div>
            <div className="avp-cms-screen-content-col50"></div>
          </div>
        </div>
      </div>
      <AvpSaveFooter
        saveCallback={footerSaveCallback}
        cancelCallback={footerCancelCallback}
      />
    </div>
  );
}
